import { createActions } from 'redux-actions'

export const TYPES = {
  DIALOG_PRODUCT_DETAILS: 'DIALOG_PRODUCT_DETAILS',
  DIALOG_REPORT_PROBLEM: 'DIALOG_REPORT_PROBLEM',
  DIALOG_RETAIL: 'DIALOG_RETAIL',
  VIEW_PRODUCTS: 'VIEW_PRODUCTS',
  VIEW_STORES: 'VIEW_STORES',
  VIEW_STORE_DETAILS: 'VIEW_STORE_DETAILS',
  VIEW_SEARCH_PRODUCTS: 'VIEW_SEARCH_PRODUCTS',
  VIEW_EMPTY: 'VIEW_EMPTY',
  VIEW_STORE_DETAILS_ALONE: 'VIEW_STORE_DETAILS_ALONE',
  VIEW_HOME_PAGE: 'VIEW_HOME_PAGE',
  VIEW_TERM: 'VIEW_TERM',
}

// const noop = () => null
const actions = {
  init: undefined,
  updateApp: undefined,
  selectProduct: undefined,
  productDetails: undefined,

  searchProducts: undefined,

  selectStore: undefined,

  snack: {
    add: undefined,
    update: undefined,
    remove: undefined,
  },

  dialog: {
    add: undefined,
    update: undefined,
    remove: undefined,
    reset: undefined,
    error: undefined,
  },

  toggleBottom: undefined,

  // @todo transformar em objeto
  storesStart: undefined,
  storesError: undefined,
  storesSuccess: undefined,
  selectStore: undefined,
  showStoreInformation: undefined,
  maximazeStoreInformation: undefined,
  minimazeStoreInformation: undefined,

  storesNotFound: undefined,

  products: { start: undefined, success: undefined, error: undefined },

  position: {
    change: undefined,
    updatePermission: undefined,
  },

  selectStore: undefined,
  chart: { data: undefined, period: undefined, load: undefined, reset: undefined },
  toggleSegment: undefined,
  clearSegments: undefined,
}

export default createActions(actions)
